// @flow

import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import type { Theme } from '../../../types';
import {
  getPower,
  getMake,
  getModel,
  getDefaultImageUrl,
  getFueltype,
  getEngine,
} from '../../../store/pdb';
import {
  toggleActivePdbId,
} from '../../../store/pdbComparison';
import { widthInUrl } from '../../../helpers';
import withErrorBoundary from '../../withErrorBoundary';

const Title = styled<any, Theme>('div')`
  font-weight: 700;
  color: ${props => props.theme.pdbCompare.titleColor};
  margin-bottom: 0.375rem;
`;

const Subtitle = styled<any, Theme>('div')`
  font-size: 0.875rem;
  color: ${props => props.theme.pdbCompare.subtitleColor};
`;

const Remove = styled<any, Theme>('div')`
  cursor: pointer;
  border: 1px solid ${props => props.theme.pdbCompare.borderColor};
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  text-align: center;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

const Icon = styled<any, Theme>('i')`
  font-size: .65rem;
  color: ${props => props.theme.pdbCompare.removeIcon};
`;

const CarTitle = styled<any, Theme>('div')`
  justify-content: flex-end;
  text-align: center;
`;

const ImageContainer = styled<any, Theme>('div')`
  img {
    max-width: 10rem;
  }
`;

type OwnProps = {
  pdbId: string, // eslint-disable-line react/no-unused-prop-types
};

type StateProps = {|
  defaultImage: ?string,
  power: string,
  make: string,
  model: string,
  engine: string,
  fueltype: string,
|};

type DispatchProps = {|
  removeItem: Function,
|};

type Props = OwnProps & StateProps & DispatchProps;

const CompareItem = ({
  defaultImage,
  power,
  make,
  model,
  engine,
  fueltype,
  removeItem,
}: Props) => (
  <>
    <Remove onClick={removeItem}>
      <Icon className="icon-cross" />
    </Remove>
    <ImageContainer>
      {defaultImage && (
        <img src={widthInUrl(defaultImage, 150)} alt={`${make} ${model}`} />
      )}
    </ImageContainer>
    <CarTitle>
      <Title>
        {make}
        {' '}
        {model}
      </Title>
      <Subtitle>
        {engine}
        {' '}
        {power}
        {' '}
        {fueltype}
      </Subtitle>
    </CarTitle>
  </>
);

const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
  power: getPower(state, pdbId),
  model: getModel(state, pdbId),
  make: getMake(state, pdbId),
  defaultImage: getDefaultImageUrl(state, pdbId),
  fueltype: getFueltype(state, pdbId),
  engine: getEngine(state, pdbId),
});

const mapDispatchToProps = (dispatch: Function, { pdbId }: OwnProps): DispatchProps => ({
  removeItem: () => dispatch(toggleActivePdbId(pdbId)),
});

export default withErrorBoundary<any, any, OwnProps, any, any>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CompareItem),
);
